import React, { useEffect } from 'react';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import Link from '@material-ui/core/Link';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import { withTranslation, WithTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';

interface BreadcrumbProps extends WithTranslation {}

const Breadcrumb = (props: BreadcrumbProps): JSX.Element => {
    const classes = useStyles();
    const { t } = props;

    const path = window.location.pathname;
    const split: string[] = path.split('/');

    const getUrls = (): string[] => {
        let urls: string[] = [];
        let tmp: string = '';
        if (path === '/') {
            urls = [path];
        } else {
            for (let i = 0; i < split.length; i++) {
                urls[i] = tmp + (tmp.endsWith('/') ? '' : '/') + split[i];
                tmp = urls[i];
            }
        }
        return urls;
    };

    const [crumbs, setCrumbs] = React.useState<string[]>(getUrls());

    useEffect(() => {
        setCrumbs(getUrls());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [path]);

    return (
        <Breadcrumbs aria-label="breadcrumb" className={classes.link}>
            {crumbs.map((url, index) => {
                const isLast = index === crumbs.length - 1;
                const label = split[index] === '' ? t('home') : t(split[index]);

                return isLast ? (
                    <span key={index} className={classes.last}>
                        {label}
                    </span>
                ) : (
                    <Link key={index} component={RouterLink} to={url} aria-label={url}>
                        {label}
                    </Link>
                );
            })}
        </Breadcrumbs>
    );
};

//=====================================//
//=============== Style ===============//
//=====================================//

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        link: {
            fontSize: 12,
            fontWeight: 300,
            color: theme.palette.colors.breadcrumb,
        },
        last: {
            color: theme.palette.secondary.main,
        },
    }),
);

export default withTranslation(['menu', 'common'])(Breadcrumb);
